import { useAutocompleteSource } from '@eas/common-web';
import { DictConcernedAuthorityTypeAutocomplete } from '@models';
import { EvidenceApiUrl } from '@enums';

export function useConcernedAuthorityTypes() {
  return useAutocompleteSource<DictConcernedAuthorityTypeAutocomplete>({
    url: `${EvidenceApiUrl.DICT_CONCERNED_AUTHORITY_TYPES}/autocomplete`,
  });
}
